import { Pipe, PipeTransform } from "@angular/core";
import { PlanningInformationType } from "../services/planning.service";

@Pipe({ name: "instructionTypeName" })
export class ExperimentDesignInstructionTypeNamePipe implements PipeTransform {
  private dictionary: { [id: number] : string } = {
    1: "Flat Instructions",
    2: "Potting Instructions",
    3: "Plant Handling Instructions"
  };

  transform(value: PlanningInformationType) {
    return this.dictionary[value];
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/pipes/design-instruction-type.pipe.ts